export const INSPECTION_CODE_PATTERN = /^[A-Z][A-Z0-9_]{1,63}$/;

export const INSPECTION_DATA_TYPE_OPTIONS = [
  { value: 'DECIMAL', label: '數值' },
  { value: 'BOOLEAN', label: '是否' },
  { value: 'SINGLE_SELECT', label: '單選' },
  { value: 'JUDGMENT', label: '判定' },
  { value: 'TEXT', label: '文字' },
];

export const DECIMAL_OPERATOR_OPTIONS = [
  { value: 'BETWEEN', label: '區間' },
  { value: 'GREATER_THAN', label: '大於' },
  { value: 'GREATER_THAN_OR_EQUAL', label: '大於等於' },
  { value: 'LESS_THAN', label: '小於' },
  { value: 'LESS_THAN_OR_EQUAL', label: '小於等於' },
  { value: 'EQUALS', label: '等於' },
];

export const TEXT_OPERATOR_OPTIONS = [
  { value: 'EXACT_EQUALS', label: '完全相符' },
  { value: 'DIRECT', label: '直接判定' },
  { value: 'RECORD_ONLY', label: '僅記錄' },
];

export const BOOLEAN_EXPECTED_OPTIONS = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

const OPERATOR_LABELS = {
  BETWEEN: '區間',
  GREATER_THAN: '大於',
  GREATER_THAN_OR_EQUAL: '大於等於',
  LESS_THAN: '小於',
  LESS_THAN_OR_EQUAL: '小於等於',
  EQUALS: '等於',
  IN: '包含於',
  DIRECT: '直接判定',
  EXACT_EQUALS: '完全相符',
  RECORD_ONLY: '僅記錄',
};

export function defaultInspectionOperator(dataType) {
  if (dataType === 'DECIMAL') {
    return 'BETWEEN';
  }
  if (dataType === 'BOOLEAN') {
    return 'EQUALS';
  }
  if (dataType === 'SINGLE_SELECT') {
    return 'IN';
  }
  return 'DIRECT';
}

export function formatInspectionDataType(dataType) {
  const match = INSPECTION_DATA_TYPE_OPTIONS.find((option) => option.value === dataType);
  return match?.label ?? (dataType || '—');
}

export function formatInspectionOperator(operator) {
  return OPERATOR_LABELS[operator] ?? (operator || '—');
}

export function formatConditionItemStatus(status) {
  if (status === 'ACTIVE') {
    return '使用中';
  }
  if (status === 'DEPRECATED') {
    return '已停用';
  }
  return status || '—';
}
